/* eslint-disable react/display-name */
//React Router v6 removes props.match.params so we need to make our own handler before we convert everything to functional components instead.
import React from 'react';
import { useParams } from 'react-router-dom';

const withRouter = WrappedComponent => props => {
    const params = useParams();
  
    return (
      <WrappedComponent
        {...props}
        params={params}
      />
    );
  };

export default withRouter;